import * as styles from "./FooterBelowPivotTable.module.scss";
export const FooterBelowPivotTable = ({ children }) => {
  return (
    <footer className={styles.Footer}>
      <div className={styles.Footer_Buttons}>{children}</div>
    </footer>
  );
};
